import { memo, useCallback } from 'react';
import { PillListActions } from 'src/components/core/PillsInput';

import { Badge, CopyText, Label, Pills, Text } from '@/components/core';
import { CloseIcon } from '@/components/icons';
import { useTriggerStore } from '@/store';
import { jsonToList, toString } from '@/utils';

export type TriggerEmailConfigurationProps = object;

// eslint-disable-next-line no-empty-pattern
const ITriggerEmailConfiguration = ({}: TriggerEmailConfigurationProps) => {
  const updateAction = useTriggerStore((state) => state.updateAction);
  const action = useTriggerStore((state) => state.action);

  const onWhitelistChange = useCallback(
    (whitelist: Pills.Item[]) => {
      updateAction((action) => {
        action.config.whitelist = whitelist.map((it) => it.value);
        return action;
      });
    },
    [updateAction]
  );

  const initialValues = jsonToList(action?.config?.whitelist).map((v) => ({ value: toString(v) }));

  return (
    <div className="gap-md p-md flex flex-col">
      <div className="flex flex-col gap-2">
        <Label>Email address</Label>
        <CopyText value={toString(action.config?.email)} />
      </div>

      <div className="flex flex-col gap-1">
        <Label>Allowlist</Label>
        <Pills.Input>
          <Pills.List
            className="flex grow"
            onItemsChange={onWhitelistChange}
            initialValues={initialValues}
            placeholder="john.doe@mydomain.com"
          >
            {(pill: Pills.Item, handle: PillListActions) => (
              <Badge variant="plain">
                <Text>{pill.value}</Text>
                <span className="ml-xs cursor-pointer" onClick={() => handle.removeItem(pill)}>
                  <CloseIcon className="size-3" />
                </span>
              </Badge>
            )}
          </Pills.List>
        </Pills.Input>

        <Text variant="plain">Only accept emails from a specified list of email addresses.</Text>
      </div>
    </div>
  );
};

export const TriggerEmailConfiguration = memo(ITriggerEmailConfiguration) as typeof ITriggerEmailConfiguration;
